// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@charset "UTF-8";
.Headline-module__font-s-10___v_zM8 {
  font-size: 10px !important;
}

.Headline-module__font-s-12___pct9G {
  font-size: 12px !important;
}

.Headline-module__font-s-13___NqCgW {
  font-size: 13px !important;
}

.Headline-module__font-s-14___gjoqY {
  font-size: 14px !important;
}

.Headline-module__font-s-15___nXocI {
  font-size: 15px !important;
}

.Headline-module__font-s-16___wsNqt {
  font-size: 16px !important;
}

.Headline-module__font-s-18___TS3bk {
  font-size: 18px !important;
}

.Headline-module__font-s-20___YyXaV {
  font-size: 20px !important;
}

.Headline-module__font-s-22___hhCMw {
  font-size: 22px !important;
}

.Headline-module__font-s-28___DyDYR {
  font-size: 28px !important;
}

.Headline-module__font-w-400___vkDG5 {
  font-weight: 400 !important;
}

.Headline-module__font-w-500___um2zz {
  font-weight: 500 !important;
}

.Headline-module__font-w-600___bboYu {
  font-weight: 600 !important;
}

.Headline-module__font-w-700___RxfXL {
  font-weight: 700 !important;
}

.Headline-module__p-5___LrvDW {
  padding: 5px !important;
}

.Headline-module__p-12___eT5Ff {
  padding: 12px !important;
}

.Headline-module__p-16___jO8S2 {
  padding: 16px !important;
}

.Headline-module__p-30___q0JtW {
  padding: 30px !important;
}

.Headline-module__p-b-0___o2zgO {
  padding-bottom: 0 !important;
}

.Headline-module__p-b-5___Yo4AT {
  padding-bottom: 5px !important;
}

.Headline-module__p-b-10___fdnTl {
  padding-bottom: 10px !important;
}

.Headline-module__p-b-12___wAZuw {
  padding-bottom: 12px !important;
}

.Headline-module__p-b-16___NLlvl {
  padding-bottom: 16px !important;
}

.Headline-module__p-b-18___zMkko {
  padding-bottom: 18px !important;
}

.Headline-module__p-b-20___FBCW2 {
  padding-bottom: 20px !important;
}

.Headline-module__p-b-25___J0mnP {
  padding-bottom: 25px !important;
}

.Headline-module__p-b-30___v7bqa {
  padding-bottom: 30px !important;
}

.Headline-module__p-b-50___K98hJ {
  padding-bottom: 50px !important;
}

.Headline-module__p-t-0___zR2Id {
  padding-top: 0 !important;
}

.Headline-module__p-t-12___voSNN {
  padding-top: 12px !important;
}

.Headline-module__p-t-16___Y24mA {
  padding-top: 16px !important;
}

.Headline-module__p-t-18___tjfbv {
  padding-top: 18px !important;
}

.Headline-module__p-t-20___fVLSf {
  padding-top: 20px !important;
}

.Headline-module__p-t-30___Nho_R {
  padding-top: 30px !important;
}

.Headline-module__p-t-40____izrG {
  padding-top: 40px !important;
}

.Headline-module__p-t-50___p2svz {
  padding-top: 50px !important;
}

.Headline-module__p-l-20___PUC9J {
  padding-left: 20px !important;
}

.Headline-module__p-l-30____9kjq {
  padding-left: 30px !important;
}

.Headline-module__p-l-40___xab9J {
  padding-left: 40px !important;
}

.Headline-module__p-r-16___Uo4b7 {
  padding-right: 16px !important;
}

.Headline-module__p-r-20___t8TA_ {
  padding-right: 20px !important;
}

.Headline-module__p-r-30___tLwSF {
  padding-right: 30px !important;
}

.Headline-module__p-r-50___rP20X {
  padding-right: 50px !important;
}

.Headline-module__p-r-60___oj7zM {
  padding-right: 60px !important;
}

.Headline-module__m-b-1___Ocbs1 {
  margin-bottom: 1px !important;
}

.Headline-module__m-b-2___RraF8 {
  margin-bottom: 2px !important;
}

.Headline-module__m-b-6___GGZHx {
  margin-bottom: 6px !important;
}

.Headline-module__m-b-8___nb8ni {
  margin-bottom: 8px !important;
}

.Headline-module__m-b-10___xbOvE {
  margin-bottom: 10px !important;
}

.Headline-module__m-b-14___2U_0Y {
  margin-bottom: 14px !important;
}

.Headline-module__m-b-16___c1lgU {
  margin-bottom: 16px !important;
}

.Headline-module__m-b-20___fSeCe {
  margin-bottom: 20px !important;
}

.Headline-module__m-b-22___PU2Ty {
  margin-bottom: 22px !important;
}

.Headline-module__m-b-24___I5471 {
  margin-bottom: 24px !important;
}

.Headline-module__m-b-30___tiZK6 {
  margin-bottom: 30px !important;
}

.Headline-module__m-b-32___SgCkS {
  margin-bottom: 32px !important;
}

.Headline-module__m-b-40___nn3cB {
  margin-bottom: 40px !important;
}

.Headline-module__m-t-2___LKufW {
  margin-top: 2px !important;
}

.Headline-module__m-t-3___VRrGn {
  margin-top: 3px !important;
}

.Headline-module__m-t-4___B1L7N {
  margin-top: 4px !important;
}

.Headline-module__m-t-5___TXy8u {
  margin-top: 5px !important;
}

.Headline-module__m-t-8___sOzYD {
  margin-top: 8px !important;
}

.Headline-module__m-t-10___TfKu3 {
  margin-top: 10px !important;
}

.Headline-module__m-t-15___QjIuE {
  margin-top: 15px !important;
}

.Headline-module__m-t-16___qBIDc {
  margin-top: 16px !important;
}

.Headline-module__m-t-20___rNwXG {
  margin-top: 20px !important;
}

.Headline-module__m-t-22___MqD8s {
  margin-top: 22px !important;
}

.Headline-module__m-t-30___t7Lfm {
  margin-top: 30px !important;
}

.Headline-module__m-t-32___PnhOL {
  margin-top: 32px !important;
}

.Headline-module__m-l-auto___mr4jU {
  margin-left: auto !important;
}

.Headline-module__m-l-4___Fkt4T {
  margin-left: 4px !important;
}

.Headline-module__m-l-5___K0Vc7 {
  margin-left: 5px !important;
}

.Headline-module__m-l-6___pVlp_ {
  margin-left: 6px !important;
}

.Headline-module__m-l-8___XTcNJ {
  margin-left: 8px !important;
}

.Headline-module__m-l-10___ekVQH {
  margin-left: 10px !important;
}

.Headline-module__m-l-16___JMpTa {
  margin-left: 16px !important;
}

.Headline-module__m-l-20___imiPI {
  margin-left: 20px !important;
}

.Headline-module__m-l-24___t2LT8 {
  margin-left: 24px !important;
}

.Headline-module__m-l-30___Btpuq {
  margin-left: 30px !important;
}

.Headline-module__m-l-35___KiuWQ {
  margin-left: 35px !important;
}

.Headline-module__m-l-40___U9dF9 {
  margin-left: 40px !important;
}

.Headline-module__m-r-8___GCvPU {
  margin-right: 8px !important;
}

.Headline-module__m-r-10___RlIs3 {
  margin-right: 10px !important;
}

.Headline-module__m-r-16___e7vvP {
  margin-right: 16px !important;
}

.Headline-module__m-r-20___hlPEq {
  margin-right: 20px !important;
}

.Headline-module__m-r-24___eU95G {
  margin-right: 24px !important;
}

.Headline-module__m-r-30___hTL_e {
  margin-right: 30px !important;
}

.Headline-module__m-r-40___tyYwc {
  margin-right: 40px !important;
}

.Headline-module__border-r-3___buMTY {
  border-radius: 3px !important;
}

.Headline-module__border-r-4___kWt1H {
  border-radius: 4px !important;
}

.Headline-module__border-r-6___dTItk {
  border-radius: 6px !important;
}

.Headline-module__border-r-10___NcwHm {
  border-radius: 10px !important;
}

.Headline-module__border-r-12___UVd7a {
  border-radius: 12px !important;
}

.Headline-module__border-r-16___wQX94 {
  border-radius: 16px !important;
}

.Headline-module__border-r-50___ndzUD {
  border-radius: 50% !important;
}

.Headline-module__primary-border___BBGX7 {
  border: 1px solid rgba(91, 91, 91, 0.2);
}

.Headline-module__primary-border-b___NnDLc {
  border-bottom: 1px solid rgba(91, 91, 91, 0.2);
}

.Headline-module__primary-border-t___tNt76 {
  border-top: 1px solid rgba(91, 91, 91, 0.2);
}

.Headline-module__primary-border-l___x8q2H {
  border-left: 1px solid rgba(91, 91, 91, 0.2);
}

.Headline-module__primary-border-r___TU3iI {
  border-right: 1px solid rgba(91, 91, 91, 0.2);
}

.Headline-module__secondary-border___p7Jv2 {
  border: 1px solid #637768;
}

.Headline-module__secondary-border-b___uFpEi {
  border-bottom: 1px solid #637768;
}

.Headline-module__secondary-border-t___DZskX {
  border-top: 1px solid #637768;
}

.Headline-module__secondary-border-l___a8JJY {
  border-left: 1px solid #637768;
}

.Headline-module__secondary-border-r___Xh2IR {
  border-right: 1px solid #637768;
}

.Headline-module__gap-0____Gzac {
  gap: 0 !important;
}

.Headline-module__gap-2___oJVk8 {
  gap: 2px !important;
}

.Headline-module__gap-4___fhHHx {
  gap: 4px !important;
}

.Headline-module__gap-5___kePvj {
  gap: 5px !important;
}

.Headline-module__gap-6___M2JRy {
  gap: 6px !important;
}

.Headline-module__gap-8___dNcAG {
  gap: 8px !important;
}

.Headline-module__gap-10___WoEl3 {
  gap: 10px !important;
}

.Headline-module__gap-12___neQpf {
  gap: 12px !important;
}

.Headline-module__gap-14___oAqHO {
  gap: 14px !important;
}

.Headline-module__gap-16___XKVnC {
  gap: 16px !important;
}

.Headline-module__gap-18___viwge {
  gap: 18px !important;
}

.Headline-module__gap-20___nZgXn {
  gap: 20px !important;
}

.Headline-module__gap-24___mSF8f {
  gap: 24px !important;
}

.Headline-module__gap-26___e23KF {
  gap: 26px !important;
}

.Headline-module__gap-30___dNhpl {
  gap: 30px !important;
}

.Headline-module__gap-32___aDKM7 {
  gap: 32px !important;
}

.Headline-module__gap-40___kTgoj {
  gap: 40px !important;
}

.Headline-module__gap-50___kudDr {
  gap: 50px !important;
}

.Headline-module__flex-1___DWsX7 {
  flex: 1;
}

.Headline-module__flex-none___Aq6sj {
  flex: none !important;
}

.Headline-module__flex-column___meZeE {
  display: flex;
  flex-direction: column !important;
}

.Headline-module__flex-row___uXTAb {
  display: flex;
  flex-direction: row !important;
}

.Headline-module__vertically-centered___rHzLx {
  display: flex;
  align-items: center !important;
}

.Headline-module__horizontally-centered___jdSRD {
  display: flex;
  justify-content: center !important;
}

.Headline-module__horizontally-end___hZmlN {
  display: flex;
  justify-content: end !important;
}

.Headline-module__vertically-start___DY2OM {
  display: flex;
  align-items: start !important;
}

.Headline-module__space-between___r6_1h {
  display: flex;
  justify-content: space-between !important;
}

.Headline-module__flex-wrap___g6jgV {
  flex-wrap: wrap !important;
}

.Headline-module__height-100___bwRSp {
  height: 100%;
}

.Headline-module__width-50___dCmv3 {
  width: 50% !important;
}

.Headline-module__width-100___wS35R {
  width: 100%;
}

.Headline-module__cursor-pointer___UuXWz {
  cursor: pointer;
}

.Headline-module__cursor-not-allowed___vfOAB {
  cursor: not-allowed !important;
}

.Headline-module__absolute-centered___JM0C7 {
  top: 50%;
  left: 50%;
  position: absolute;
  transform: translate(-50%, -50%);
}

.Headline-module__absolute___lQE5R {
  position: absolute;
}

.Headline-module__relative___LJ4aZ {
  position: relative;
}

.Headline-module__fixed___VwkV6 {
  position: fixed;
}

.Headline-module__visible___o9wCN {
  opacity: 1;
}

.Headline-module__invisible___IlB87 {
  opacity: 0;
}

.Headline-module__col-90___OeNsZ {
  width: 90% !important;
}

.Headline-module__col-auto___VBDzp {
  width: auto !important;
}

.Headline-module__medical-tabs___JIdyD {
  gap: 30px;
  padding: 0 !important;
  margin: 20px 40px -5px 40px;
}

.Headline-module__medical-table-new___ia_hr {
  height: calc(100vh - var(--tabs-navigation) - var(--patient-details-header) - var(--secondary-navigation) - var(--patient-details-footer) - var(--table-tabs) - var(--table-pagination));
  overflow-y: scroll;
  overflow-x: hidden;
}
.Headline-module__medical-table-new___ia_hr:hover::-webkit-scrollbar-thumb {
  background-color: rgb(125, 123, 121);
  border-radius: 10px;
}
.Headline-module__medical-table-new___ia_hr::-webkit-scrollbar {
  width: 5px;
  background-color: transparent;
}
.Headline-module__medical-table-new___ia_hr::-webkit-scrollbar-track {
  display: none;
}
.Headline-module__medical-table-new___ia_hr.Headline-module__no-pagination___HcoQO {
  height: calc(100vh - var(--tabs-navigation) - var(--patient-details-header) - var(--secondary-navigation) - var(--patient-details-footer) - var(--table-tabs));
  overflow-y: scroll;
  overflow-x: hidden;
}
.Headline-module__medical-table-new___ia_hr.Headline-module__no-pagination___HcoQO:hover::-webkit-scrollbar-thumb {
  background-color: rgb(125, 123, 121);
  border-radius: 10px;
}
.Headline-module__medical-table-new___ia_hr.Headline-module__no-pagination___HcoQO::-webkit-scrollbar {
  width: 5px;
  background-color: transparent;
}
.Headline-module__medical-table-new___ia_hr.Headline-module__no-pagination___HcoQO::-webkit-scrollbar-track {
  display: none;
}

.Headline-module__medical-table-empty___snko0 {
  padding: 14px 40px !important;
}

.Headline-module__icon-btn___APFtE {
  width: 22px;
  height: 22px;
  cursor: pointer;
}

.Headline-module__search-icon___lH97p {
  width: 24px;
  height: 24px;
  align-self: center;
}

.Headline-module__disable-select___ZUKe6 {
  user-select: none;
}

.Headline-module__break-word___t3_uC {
  word-break: break-word;
}

.Headline-module__popup-clear-btn___HZDu3 {
  display: flex;
  align-self: center;
  cursor: pointer;
  font-weight: 500;
  font-size: 14px;
  line-height: 150%;
  color: #f06c67;
}

.Headline-module__scroll-m-b-20___I_KFH {
  scroll-margin-bottom: 20px;
}

.Headline-module__row___hMMRW {
  display: flex;
  align-items: stretch;
}

.Headline-module__divider___vtgYp {
  border-bottom: 1px solid #e4e4e7;
}

.Headline-module__cardBody___cpwgO {
  display: flex;
  min-width: 0;
  flex: 1;
  align-items: center;
  gap: 6px;
  padding: 12px 20px;
}

.Headline-module__afterCorner___BuQUN {
  padding-left: 16px;
}

.Headline-module__titleStack___LpzVh {
  display: flex;
  min-width: 0;
  flex: 1;
  flex-direction: column;
  gap: 2px;
}

.Headline-module__title___nmNOd {
  display: inline-flex;
  min-width: 0;
  align-items: center;
  gap: 8px;
  font-size: 15px;
  font-weight: 500;
  color: #18181b;
}

.Headline-module__inlineStack___AlJTS {
  margin: 1px 0;
  display: flex;
  min-width: 0;
  flex: 1;
  flex-wrap: wrap;
  align-items: baseline;
  gap: 2px 8px;
}

.Headline-module__inlineTitle___B1w_s {
  font-size: 17px;
  line-height: 26px;
}

.Headline-module__toggleTitle___mzAYT {
  padding: 0;
  border: 0;
  background: transparent;
  font: inherit;
  font-weight: inherit;
  color: inherit;
  text-align: left;
  cursor: pointer;
}
.Headline-module__toggleTitle___mzAYT:focus-visible {
  outline: none;
}
.Headline-module__toggleTitle___mzAYT:focus-visible:focus-visible {
  outline: 2px solid #18181b;
  outline-offset: 1px;
}

.Headline-module__inlineTime___ypTvH {
  white-space: nowrap;
}

.Headline-module__timeLine___tVP63 {
  overflow: hidden;
  font-size: 13px;
  line-height: 1.4286;
  font-variant-numeric: tabular-nums;
  color: #71717a;
}

.Headline-module__local___xrm9X {
  color: #a1a1aa;
}

.Headline-module__timeParts___hvVPV {
  display: flex;
  flex-wrap: wrap;
  margin-left: -0.9em;
}

.Headline-module__timePart___VQxA8 {
  white-space: nowrap;
}
.Headline-module__timePart___VQxA8::before {
  content: "·";
  display: inline-block;
  width: 0.9em;
  text-align: center;
  font-weight: 400;
  color: #71717a;
}

.Headline-module__when___qxgeN {
  font-weight: 500;
}

.Headline-module__soon___hbH85 {
  font-weight: 600;
  color: #18181b;
}

.Headline-module__aside___laThH {
  display: flex;
  flex-shrink: 0;
  align-items: center;
  gap: 6px;
}

.Headline-module__panelBody___E09Ei {
  display: flex;
  min-width: 0;
  flex: 1;
  align-items: flex-start;
  gap: 12px;
  padding: 13px 20px;
}

.Headline-module__panelText___kpToN {
  display: flex;
  min-width: 0;
  flex: 1;
  flex-direction: column;
  gap: 2px;
}

.Headline-module__panelTitle___NwVUD {
  margin: 0;
  font-size: 17px;
  font-weight: 600;
  line-height: 1.35;
  color: #18181b;
}

.Headline-module__muted___rFGKa {
  opacity: 0.7;
}

.Headline-module__visitLine___jvPj1 {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 4px 8px;
  margin: 0;
  font-size: 15px;
  line-height: 1.5;
  color: #3f3f46;
}

.Headline-module__visitName___ohKM_ {
  font-weight: 500;
  color: #18181b;
}

.Headline-module__description___gFCoL {
  margin: 0;
  font-size: 13px;
  line-height: 1.5;
  color: #71717a;
}

.Headline-module__actions___Cy3jM {
  display: flex;
  flex-shrink: 0;
  align-items: center;
  gap: 6px;
  padding-top: 2px;
}

.Headline-module__panelBodyLarge___rXPw0 {
  flex-wrap: wrap;
  align-items: center;
  gap: 12px 16px;
}

.Headline-module__panelTextLarge___vba4a {
  flex: 0 1 auto;
  margin-right: auto;
}

.Headline-module__panelTitleLarge___zKlSx {
  display: flex;
  flex-wrap: wrap;
  align-items: baseline;
  gap: 0 8px;
  font-size: 20px;
  line-height: 1.42;
}`, "",{"version":3,"sources":["webpack://./src/pages/CareOrchestration/components/Visit/Headline.module.scss","webpack://./../common/src/styles/global/_base.scss","webpack://./../common/src/styles/global/_mixins.scss","webpack://./../common/src/styles/global/_visit.scss"],"names":[],"mappings":"AAAA,gBAAgB;ACIhB;EACE,0BAAA;ADFF;;ACKA;EACE,0BAAA;ADFF;;ACKA;EACE,0BAAA;ADFF;;ACKA;EACE,0BAAA;ADFF;;ACKA;EACE,0BAAA;ADFF;;ACKA;EACE,0BAAA;ADFF;;ACKA;EACE,0BAAA;ADFF;;ACKA;EACE,0BAAA;ADFF;;ACKA;EACE,0BAAA;ADFF;;ACKA;EACE,0BAAA;ADFF;;ACKA;EACE,2BAAA;ADFF;;ACKA;EACE,2BAAA;ADFF;;ACKA;EACE,2BAAA;ADFF;;ACKA;EACE,2BAAA;ADFF;;ACMA;EACE,uBAAA;ADHF;;ACMA;EACE,wBAAA;ADHF;;ACMA;EACE,wBAAA;ADHF;;ACMA;EACE,wBAAA;ADHF;;ACMA;EACE,4BAAA;ADHF;;ACMA;EACE,8BAAA;ADHF;;ACMA;EACE,+BAAA;ADHF;;ACMA;EACE,+BAAA;ADHF;;ACMA;EACE,+BAAA;ADHF;;ACMA;EACE,+BAAA;ADHF;;ACMA;EACE,+BAAA;ADHF;;ACMA;EACE,+BAAA;ADHF;;ACMA;EACE,+BAAA;ADHF;;ACMA;EACE,+BAAA;ADHF;;ACMA;EACE,yBAAA;ADHF;;ACMA;EACE,4BAAA;ADHF;;ACMA;EACE,4BAAA;ADHF;;ACMA;EACE,4BAAA;ADHF;;ACMA;EACE,4BAAA;ADHF;;ACMA;EACE,4BAAA;ADHF;;ACMA;EACE,4BAAA;ADHF;;ACMA;EACE,4BAAA;ADHF;;ACMA;EACE,6BAAA;ADHF;;ACMA;EACE,6BAAA;ADHF;;ACMA;EACE,6BAAA;ADHF;;ACMA;EACE,8BAAA;ADHF;;ACMA;EACE,8BAAA;ADHF;;ACMA;EACE,8BAAA;ADHF;;ACMA;EACE,8BAAA;ADHF;;ACMA;EACE,8BAAA;ADHF;;ACOA;EACE,6BAAA;ADJF;;ACOA;EACE,6BAAA;ADJF;;ACOA;EACE,6BAAA;ADJF;;ACOA;EACE,6BAAA;ADJF;;ACOA;EACE,8BAAA;ADJF;;ACOA;EACE,8BAAA;ADJF;;ACOA;EACE,8BAAA;ADJF;;ACOA;EACE,8BAAA;ADJF;;ACOA;EACE,8BAAA;ADJF;;ACOA;EACE,8BAAA;ADJF;;ACOA;EACE,8BAAA;ADJF;;ACOA;EACE,8BAAA;ADJF;;ACOA;EACE,8BAAA;ADJF;;ACOA;EACE,0BAAA;ADJF;;ACOA;EACE,0BAAA;ADJF;;ACOA;EACE,0BAAA;ADJF;;ACOA;EACE,0BAAA;ADJF;;ACOA;EACE,0BAAA;ADJF;;ACOA;EACE,2BAAA;ADJF;;ACOA;EACE,2BAAA;ADJF;;ACOA;EACE,2BAAA;ADJF;;ACOA;EACE,2BAAA;ADJF;;ACOA;EACE,2BAAA;ADJF;;ACOA;EACE,2BAAA;ADJF;;ACOA;EACE,2BAAA;ADJF;;ACOA;EACE,4BAAA;ADJF;;ACOA;EACE,2BAAA;ADJF;;ACOA;EACE,2BAAA;ADJF;;ACOA;EACE,2BAAA;ADJF;;ACOA;EACE,2BAAA;ADJF;;ACOA;EACE,4BAAA;ADJF;;ACOA;EACE,4BAAA;ADJF;;ACOA;EACE,4BAAA;ADJF;;ACOA;EACE,4BAAA;ADJF;;ACOA;EACE,4BAAA;ADJF;;ACOA;EACE,4BAAA;ADJF;;ACOA;EACE,4BAAA;ADJF;;ACOA;EACE,4BAAA;ADJF;;ACOA;EACE,6BAAA;ADJF;;ACOA;EACE,6BAAA;ADJF;;ACOA;EACE,6BAAA;ADJF;;ACOA;EACE,6BAAA;ADJF;;ACOA;EACE,6BAAA;ADJF;;ACOA;EACE,6BAAA;ADJF;;ACQA;EACE,6BAAA;ADLF;;ACQA;EACE,6BAAA;ADLF;;ACQA;EACE,6BAAA;ADLF;;ACQA;EACE,8BAAA;ADLF;;ACQA;EACE,8BAAA;ADLF;;ACQA;EACE,8BAAA;ADLF;;ACQA;EACE,6BAAA;ADLF;;ACQA;EACE,uCAAA;ADLF;;ACQA;EACE,8CAAA;ADLF;;ACQA;EACE,2CAAA;ADLF;;ACQA;EACE,4CAAA;ADLF;;ACQA;EACE,6CAAA;ADLF;;ACQA;EACE,yBAAA;ADLF;;ACQA;EACE,gCAAA;ADLF;;ACQA;EACE,6BAAA;ADLF;;ACQA;EACE,8BAAA;ADLF;;ACQA;EACE,+BAAA;ADLF;;ACSA;EACE,iBAAA;ADNF;;ACSA;EACE,mBAAA;ADNF;;ACSA;EACE,mBAAA;ADNF;;ACSA;EACE,mBAAA;ADNF;;ACSA;EACE,mBAAA;ADNF;;ACSA;EACE,mBAAA;ADNF;;ACSA;EACE,oBAAA;ADNF;;ACSA;EACE,oBAAA;ADNF;;ACSA;EACE,oBAAA;ADNF;;ACSA;EACE,oBAAA;ADNF;;ACSA;EACE,oBAAA;ADNF;;ACSA;EACE,oBAAA;ADNF;;ACSA;EACE,oBAAA;ADNF;;ACSA;EACE,oBAAA;ADNF;;ACSA;EACE,oBAAA;ADNF;;ACSA;EACE,oBAAA;ADNF;;ACSA;EACE,oBAAA;ADNF;;ACSA;EACE,oBAAA;ADNF;;ACSA;EACE,OAAA;ADNF;;ACSA;EACE,qBAAA;ADNF;;ACSA;EACE,aAAA;EACA,iCAAA;ADNF;;ACSA;EACE,aAAA;EACA,8BAAA;ADNF;;ACSA;EACE,aAAA;EACA,8BAAA;ADNF;;ACSA;EACE,aAAA;EACA,kCAAA;ADNF;;ACSA;EACE,aAAA;EACA,+BAAA;ADNF;;ACSA;EACE,aAAA;EACA,6BAAA;ADNF;;ACSA;EACE,aAAA;EACA,yCAAA;ADNF;;ACSA;EACE,0BAAA;ADNF;;ACUA;EACE,YAAA;ADPF;;ACUA;EACE,qBAAA;ADPF;;ACUA;EACE,WAAA;ADPF;;ACWA;EACE,eAAA;ADRF;;ACWA;EACE,8BAAA;ADRF;;ACYA;EACE,QAAA;EACA,SAAA;EACA,kBAAA;EACA,gCAAA;ADTF;;ACYA;EACE,kBAAA;ADTF;;ACYA;EACE,kBAAA;ADTF;;ACYA;EACE,eAAA;ADTF;;ACaA;EACE,UAAA;ADVF;;ACaA;EACE,UAAA;ADVF;;ACcA;EACE,qBAAA;ADXF;;ACcA;EACE,sBAAA;ADXF;;ACeA;EACE,SAAA;EACA,qBAAA;EACA,2BAAA;ADZF;;ACeA;EC5lBE,wLD8lBE;EC7lBF,kBAAA;EACA,kBAAA;AFilBF;AE/kBE;EACE,oCAAA;EACA,mBAAA;AFilBJ;AE9kBE;EACE,UAAA;EACA,6BAAA;AFglBJ;AE7kBE;EACE,aAAA;AF+kBJ;ACOE;ECrmBA,8JDumBI;ECtmBJ,kBAAA;EACA,kBAAA;AFimBF;AE/lBE;EACE,oCAAA;EACA,mBAAA;AFimBJ;AE9lBE;EACE,UAAA;EACA,6BAAA;AFgmBJ;AE7lBE;EACE,aAAA;AF+lBJ;;ACEA;EACE,6BAAA;ADCF;;ACGA;EACE,WAAA;EACA,YAAA;EACA,eAAA;ADAF;;ACGA;EACE,WAAA;EACA,YAAA;EACA,kBAAA;ADAF;;ACGA;EACE,iBAAA;ADAF;;ACGA;EACE,sBAAA;ADAF;;ACGA;EACE,aAAA;EACA,kBAAA;EACA,eAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,cAAA;ADAF;;ACGA;EACE,0BAAA;ADAF;;AA5pBA;EACE,aAAA;EACA,oBAAA;AA+pBF;;AA5pBA;EACE,gCAAA;AA+pBF;;AA5pBA;EACE,aAAA;EACA,YAAA;EACA,OAAA;EACA,mBAAA;EACA,QAAA;EACA,kBAAA;AA+pBF;;AA5pBA;EACE,kBAAA;AA+pBF;;AA5pBA;EACE,aAAA;EACA,YAAA;EACA,OAAA;EACA,sBAAA;EACA,QAAA;AA+pBF;;AA5pBA;EACE,oBAAA;EACA,YAAA;EACA,mBAAA;EACA,QAAA;EACA,eAAA;EACA,gBAAA;EACA,cAAA;AA+pBF;;AA5pBA;EACE,aAAA;EACA,aAAA;EACA,YAAA;EACA,OAAA;EACA,eAAA;EACA,qBAAA;EACA,YAAA;AA+pBF;;AA5pBA;EACE,eAAA;EACA,iBAAA;AA+pBF;;AA5pBA;EACE,UAAA;EACA,SAAA;EACA,uBAAA;EACA,aAAA;EACA,oBAAA;EACA,cAAA;EACA,gBAAA;EACA,eAAA;AA+pBF;AA7pBE;EG5BA,aAAA;AH4rBF;AG1rBE;EACE,0BAAA;EACA,mBALuB;AHisB3B;;AA/pBA;EACE,mBAAA;AAkqBF;;AA/pBA;EACE,gBAAA;EACA,eAAA;EACA,mBAAA;EACA,kCAAA;EACA,cG1EM;AH4uBR;;AA/pBA;EACE,cAAA;AAkqBF;;AA/pBA;EACE,aAAA;EACA,eAAA;EACA,mBAAA;AAkqBF;;AA/pBA;EACE,mBAAA;AAkqBF;AAhqBE;EACE,YAAA;EACA,qBAAA;EACA,YAAA;EACA,kBAAA;EACA,gBAAA;EACA,cGhGI;AHkwBR;;AA9pBA;EACE,gBAAA;AAiqBF;;AA9pBA;EACE,gBAAA;EACA,cAAA;AAiqBF;;AA9pBA;EACE,aAAA;EACA,cAAA;EACA,mBAAA;EACA,QAAA;AAiqBF;;AA9pBA;EACE,aAAA;EACA,YAAA;EACA,OAAA;EACA,uBAAA;EACA,SAAA;EACA,kBAAA;AAiqBF;;AA9pBA;EACE,aAAA;EACA,YAAA;EACA,OAAA;EACA,sBAAA;EACA,QAAA;AAiqBF;;AA9pBA;EACE,SAAA;EACA,eAAA;EACA,gBAAA;EACA,iBAAA;EACA,cAAA;AAiqBF;;AA9pBA;EACE,YAAA;AAiqBF;;AA9pBA;EACE,aAAA;EACA,eAAA;EACA,mBAAA;EACA,YAAA;EACA,SAAA;EACA,eAAA;EACA,gBAAA;EACA,cAAA;AAiqBF;;AA9pBA;EACE,gBAAA;EACA,cAAA;AAiqBF;;AA9pBA;EACE,SAAA;EACA,eAAA;EACA,gBAAA;EACA,cGrKM;AHs0BR;;AA9pBA;EACE,aAAA;EACA,cAAA;EACA,mBAAA;EACA,QAAA;EACA,gBAAA;AAiqBF;;AA9pBA;EACE,eAAA;EACA,mBAAA;EACA,cAAA;AAiqBF;;AA9pBA;EACE,cAAA;EACA,kBAAA;AAiqBF;;AA9pBA;EACE,aAAA;EACA,eAAA;EACA,qBAAA;EACA,UAAA;EACA,eAAA;EACA,iBAAA;AAiqBF","sourcesContent":["@use 'common-src/styles/global' as *;\n\n.row {\n  display: flex;\n  align-items: stretch;\n}\n\n.divider {\n  border-bottom: 1px solid $hairline;\n}\n\n.cardBody {\n  display: flex;\n  min-width: 0;\n  flex: 1;\n  align-items: center;\n  gap: 6px;\n  padding: 12px 20px;\n}\n\n.afterCorner {\n  padding-left: 16px;\n}\n\n.titleStack {\n  display: flex;\n  min-width: 0;\n  flex: 1;\n  flex-direction: column;\n  gap: 2px;\n}\n\n.title {\n  display: inline-flex;\n  min-width: 0;\n  align-items: center;\n  gap: 8px;\n  font-size: 15px;\n  font-weight: 500;\n  color: #18181b;\n}\n\n.inlineStack {\n  margin: 1px 0;\n  display: flex;\n  min-width: 0;\n  flex: 1;\n  flex-wrap: wrap;\n  align-items: baseline;\n  gap: 2px 8px;\n}\n\n.inlineTitle {\n  font-size: 17px;\n  line-height: 26px;\n}\n\n.toggleTitle {\n  padding: 0;\n  border: 0;\n  background: transparent;\n  font: inherit;\n  font-weight: inherit;\n  color: inherit;\n  text-align: left;\n  cursor: pointer;\n\n  &:focus-visible {\n    @include focus-ring;\n  }\n}\n\n.inlineTime {\n  white-space: nowrap;\n}\n\n.timeLine {\n  overflow: hidden;\n  font-size: 13px;\n  line-height: 1.4286;\n  font-variant-numeric: tabular-nums;\n  color: $label;\n}\n\n.local {\n  color: #a1a1aa;\n}\n\n.timeParts {\n  display: flex;\n  flex-wrap: wrap;\n  margin-left: -0.9em;\n}\n\n.timePart {\n  white-space: nowrap;\n\n  &::before {\n    content: '·';\n    display: inline-block;\n    width: 0.9em;\n    text-align: center;\n    font-weight: 400;\n    color: $label;\n  }\n}\n\n.when {\n  font-weight: 500;\n}\n\n.soon {\n  font-weight: 600;\n  color: #18181b;\n}\n\n.aside {\n  display: flex;\n  flex-shrink: 0;\n  align-items: center;\n  gap: 6px;\n}\n\n.panelBody {\n  display: flex;\n  min-width: 0;\n  flex: 1;\n  align-items: flex-start;\n  gap: 12px;\n  padding: 13px 20px;\n}\n\n.panelText {\n  display: flex;\n  min-width: 0;\n  flex: 1;\n  flex-direction: column;\n  gap: 2px;\n}\n\n.panelTitle {\n  margin: 0;\n  font-size: 17px;\n  font-weight: 600;\n  line-height: 1.35;\n  color: #18181b;\n}\n\n.muted {\n  opacity: 0.7;\n}\n\n.visitLine {\n  display: flex;\n  flex-wrap: wrap;\n  align-items: center;\n  gap: 4px 8px;\n  margin: 0;\n  font-size: 15px;\n  line-height: 1.5;\n  color: #3f3f46;\n}\n\n.visitName {\n  font-weight: 500;\n  color: #18181b;\n}\n\n.description {\n  margin: 0;\n  font-size: 13px;\n  line-height: 1.5;\n  color: $label;\n}\n\n.actions {\n  display: flex;\n  flex-shrink: 0;\n  align-items: center;\n  gap: 6px;\n  padding-top: 2px;\n}\n\n.panelBodyLarge {\n  flex-wrap: wrap;\n  align-items: center;\n  gap: 12px 16px;\n}\n\n.panelTextLarge {\n  flex: 0 1 auto;\n  margin-right: auto;\n}\n\n.panelTitleLarge {\n  display: flex;\n  flex-wrap: wrap;\n  align-items: baseline;\n  gap: 0 8px;\n  font-size: 20px;\n  line-height: 1.42;\n}\n","@use 'mixins';\n@use 'functions';\n\n// font\n.font-s-10 {\n  font-size: 10px !important;\n}\n\n.font-s-12 {\n  font-size: 12px !important;\n}\n\n.font-s-13 {\n  font-size: 13px !important;\n}\n\n.font-s-14 {\n  font-size: 14px !important;\n}\n\n.font-s-15 {\n  font-size: 15px !important;\n}\n\n.font-s-16 {\n  font-size: 16px !important;\n}\n\n.font-s-18 {\n  font-size: 18px !important;\n}\n\n.font-s-20 {\n  font-size: 20px !important;\n}\n\n.font-s-22 {\n  font-size: 22px !important;\n}\n\n.font-s-28 {\n  font-size: 28px !important;\n}\n\n.font-w-400 {\n  font-weight: 400 !important;\n}\n\n.font-w-500 {\n  font-weight: 500 !important;\n}\n\n.font-w-600 {\n  font-weight: 600 !important;\n}\n\n.font-w-700 {\n  font-weight: 700 !important;\n}\n\n// padding\n.p-5 {\n  padding: 5px !important;\n}\n\n.p-12 {\n  padding: 12px !important;\n}\n\n.p-16 {\n  padding: 16px !important;\n}\n\n.p-30 {\n  padding: 30px !important;\n}\n\n.p-b-0 {\n  padding-bottom: 0 !important;\n}\n\n.p-b-5 {\n  padding-bottom: 5px !important;\n}\n\n.p-b-10 {\n  padding-bottom: 10px !important;\n}\n\n.p-b-12 {\n  padding-bottom: 12px !important;\n}\n\n.p-b-16 {\n  padding-bottom: 16px !important;\n}\n\n.p-b-18 {\n  padding-bottom: 18px !important;\n}\n\n.p-b-20 {\n  padding-bottom: 20px !important;\n}\n\n.p-b-25 {\n  padding-bottom: 25px !important;\n}\n\n.p-b-30 {\n  padding-bottom: 30px !important;\n}\n\n.p-b-50 {\n  padding-bottom: 50px !important;\n}\n\n.p-t-0 {\n  padding-top: 0 !important;\n}\n\n.p-t-12 {\n  padding-top: 12px !important;\n}\n\n.p-t-16 {\n  padding-top: 16px !important;\n}\n\n.p-t-18 {\n  padding-top: 18px !important;\n}\n\n.p-t-20 {\n  padding-top: 20px !important;\n}\n\n.p-t-30 {\n  padding-top: 30px !important;\n}\n\n.p-t-40 {\n  padding-top: 40px !important;\n}\n\n.p-t-50 {\n  padding-top: 50px !important;\n}\n\n.p-l-20 {\n  padding-left: 20px !important;\n}\n\n.p-l-30 {\n  padding-left: 30px !important;\n}\n\n.p-l-40 {\n  padding-left: 40px !important;\n}\n\n.p-r-16 {\n  padding-right: 16px !important;\n}\n\n.p-r-20 {\n  padding-right: 20px !important;\n}\n\n.p-r-30 {\n  padding-right: 30px !important;\n}\n\n.p-r-50 {\n  padding-right: 50px !important;\n}\n\n.p-r-60 {\n  padding-right: 60px !important;\n}\n\n// margin\n.m-b-1 {\n  margin-bottom: 1px !important;\n}\n\n.m-b-2 {\n  margin-bottom: 2px !important;\n}\n\n.m-b-6 {\n  margin-bottom: 6px !important;\n}\n\n.m-b-8 {\n  margin-bottom: 8px !important;\n}\n\n.m-b-10 {\n  margin-bottom: 10px !important;\n}\n\n.m-b-14 {\n  margin-bottom: 14px !important;\n}\n\n.m-b-16 {\n  margin-bottom: 16px !important;\n}\n\n.m-b-20 {\n  margin-bottom: 20px !important;\n}\n\n.m-b-22 {\n  margin-bottom: 22px !important;\n}\n\n.m-b-24 {\n  margin-bottom: 24px !important;\n}\n\n.m-b-30 {\n  margin-bottom: 30px !important;\n}\n\n.m-b-32 {\n  margin-bottom: 32px !important;\n}\n\n.m-b-40 {\n  margin-bottom: 40px !important;\n}\n\n.m-t-2 {\n  margin-top: 2px !important;\n}\n\n.m-t-3 {\n  margin-top: 3px !important;\n}\n\n.m-t-4 {\n  margin-top: 4px !important;\n}\n\n.m-t-5 {\n  margin-top: 5px !important;\n}\n\n.m-t-8 {\n  margin-top: 8px !important;\n}\n\n.m-t-10 {\n  margin-top: 10px !important;\n}\n\n.m-t-15 {\n  margin-top: 15px !important;\n}\n\n.m-t-16 {\n  margin-top: 16px !important;\n}\n\n.m-t-20 {\n  margin-top: 20px !important;\n}\n\n.m-t-22 {\n  margin-top: 22px !important;\n}\n\n.m-t-30 {\n  margin-top: 30px !important;\n}\n\n.m-t-32 {\n  margin-top: 32px !important;\n}\n\n.m-l-auto {\n  margin-left: auto !important;\n}\n\n.m-l-4 {\n  margin-left: 4px !important;\n}\n\n.m-l-5 {\n  margin-left: 5px !important;\n}\n\n.m-l-6 {\n  margin-left: 6px !important;\n}\n\n.m-l-8 {\n  margin-left: 8px !important;\n}\n\n.m-l-10 {\n  margin-left: 10px !important;\n}\n\n.m-l-16 {\n  margin-left: 16px !important;\n}\n\n.m-l-20 {\n  margin-left: 20px !important;\n}\n\n.m-l-24 {\n  margin-left: 24px !important;\n}\n\n.m-l-30 {\n  margin-left: 30px !important;\n}\n\n.m-l-35 {\n  margin-left: 35px !important;\n}\n\n.m-l-40 {\n  margin-left: 40px !important;\n}\n\n.m-r-8 {\n  margin-right: 8px !important;\n}\n\n.m-r-10 {\n  margin-right: 10px !important;\n}\n\n.m-r-16 {\n  margin-right: 16px !important;\n}\n\n.m-r-20 {\n  margin-right: 20px !important;\n}\n\n.m-r-24 {\n  margin-right: 24px !important;\n}\n\n.m-r-30 {\n  margin-right: 30px !important;\n}\n\n.m-r-40 {\n  margin-right: 40px !important;\n}\n\n// border\n.border-r-3 {\n  border-radius: 3px !important;\n}\n\n.border-r-4 {\n  border-radius: 4px !important;\n}\n\n.border-r-6 {\n  border-radius: 6px !important;\n}\n\n.border-r-10 {\n  border-radius: 10px !important;\n}\n\n.border-r-12 {\n  border-radius: 12px !important;\n}\n\n.border-r-16 {\n  border-radius: 16px !important;\n}\n\n.border-r-50 {\n  border-radius: 50% !important;\n}\n\n.primary-border {\n  border: 1px solid rgba(91, 91, 91, 0.2);\n}\n\n.primary-border-b {\n  border-bottom: 1px solid rgba(91, 91, 91, 0.2);\n}\n\n.primary-border-t {\n  border-top: 1px solid rgba(91, 91, 91, 0.2);\n}\n\n.primary-border-l {\n  border-left: 1px solid rgba(91, 91, 91, 0.2);\n}\n\n.primary-border-r {\n  border-right: 1px solid rgba(91, 91, 91, 0.2);\n}\n\n.secondary-border {\n  border: 1px solid functions.get-color(greenNew, medium-dark);\n}\n\n.secondary-border-b {\n  border-bottom: 1px solid functions.get-color(greenNew, medium-dark);\n}\n\n.secondary-border-t {\n  border-top: 1px solid functions.get-color(greenNew, medium-dark);\n}\n\n.secondary-border-l {\n  border-left: 1px solid functions.get-color(greenNew, medium-dark);\n}\n\n.secondary-border-r {\n  border-right: 1px solid functions.get-color(greenNew, medium-dark);\n}\n\n// flex\n.gap-0 {\n  gap: 0 !important;\n}\n\n.gap-2 {\n  gap: 2px !important;\n}\n\n.gap-4 {\n  gap: 4px !important;\n}\n\n.gap-5 {\n  gap: 5px !important;\n}\n\n.gap-6 {\n  gap: 6px !important;\n}\n\n.gap-8 {\n  gap: 8px !important;\n}\n\n.gap-10 {\n  gap: 10px !important;\n}\n\n.gap-12 {\n  gap: 12px !important;\n}\n\n.gap-14 {\n  gap: 14px !important;\n}\n\n.gap-16 {\n  gap: 16px !important;\n}\n\n.gap-18 {\n  gap: 18px !important;\n}\n\n.gap-20 {\n  gap: 20px !important;\n}\n\n.gap-24 {\n  gap: 24px !important;\n}\n\n.gap-26 {\n  gap: 26px !important;\n}\n\n.gap-30 {\n  gap: 30px !important;\n}\n\n.gap-32 {\n  gap: 32px !important;\n}\n\n.gap-40 {\n  gap: 40px !important;\n}\n\n.gap-50 {\n  gap: 50px !important;\n}\n\n.flex-1 {\n  flex: 1;\n}\n\n.flex-none {\n  flex: none !important;\n}\n\n.flex-column {\n  display: flex;\n  flex-direction: column !important;\n}\n\n.flex-row {\n  display: flex;\n  flex-direction: row !important;\n}\n\n.vertically-centered {\n  display: flex;\n  align-items: center !important;\n}\n\n.horizontally-centered {\n  display: flex;\n  justify-content: center !important;\n}\n\n.horizontally-end {\n  display: flex;\n  justify-content: end !important;\n}\n\n.vertically-start {\n  display: flex;\n  align-items: start !important;\n}\n\n.space-between {\n  display: flex;\n  justify-content: space-between !important;\n}\n\n.flex-wrap {\n  flex-wrap: wrap !important;\n}\n\n// width and height\n.height-100 {\n  height: 100%;\n}\n\n.width-50 {\n  width: 50% !important;\n}\n\n.width-100 {\n  width: 100%;\n}\n\n// cursor\n.cursor-pointer {\n  cursor: pointer;\n}\n\n.cursor-not-allowed {\n  cursor: not-allowed !important;\n}\n\n// position\n.absolute-centered {\n  top: 50%;\n  left: 50%;\n  position: absolute;\n  transform: translate(-50%, -50%);\n}\n\n.absolute {\n  position: absolute;\n}\n\n.relative {\n  position: relative;\n}\n\n.fixed {\n  position: fixed;\n}\n\n// visibility\n.visible {\n  opacity: 1;\n}\n\n.invisible {\n  opacity: 0;\n}\n\n// layout\n.col-90 {\n  width: 90% !important;\n}\n\n.col-auto {\n  width: auto !important;\n}\n\n// medical fragments\n.medical-tabs {\n  gap: 30px;\n  padding: 0 !important;\n  margin: 20px 40px -5px 40px;\n}\n\n.medical-table-new {\n  @include mixins.verticalScroll(\n    calc(\n      100vh - var(--tabs-navigation) - var(--patient-details-header) - var(\n          --secondary-navigation\n        ) - var(--patient-details-footer) - var(--table-tabs) - var(--table-pagination)\n    )\n  );\n\n  &.no-pagination {\n    @include mixins.verticalScroll(\n      calc(\n        100vh - var(--tabs-navigation) - var(--patient-details-header) - var(\n            --secondary-navigation\n          ) - var(--patient-details-footer) - var(--table-tabs)\n      )\n    );\n  }\n}\n\n.medical-table-empty {\n  padding: 14px 40px !important;\n}\n\n//\n.icon-btn {\n  width: 22px;\n  height: 22px;\n  cursor: pointer;\n}\n\n.search-icon {\n  width: 24px;\n  height: 24px;\n  align-self: center;\n}\n\n.disable-select {\n  user-select: none;\n}\n\n.break-word {\n  word-break: break-word;\n}\n\n.popup-clear-btn {\n  display: flex;\n  align-self: center;\n  cursor: pointer;\n  font-weight: 500;\n  font-size: 14px;\n  line-height: 150%;\n  color: functions.get-color(redNew, medium-dark);\n}\n\n.scroll-m-b-20 {\n  scroll-margin-bottom: 20px;\n}\n","@forward 'sizes';\n@forward 'variables';\n\n@mixin clipped-text {\n  overflow: hidden;\n  white-space: nowrap;\n  text-overflow: ellipsis;\n}\n\n@mixin verticalScroll($height) {\n  height: $height;\n  overflow-y: scroll;\n  overflow-x: hidden;\n\n  &:hover::-webkit-scrollbar-thumb {\n    background-color: rgb(125, 123, 121);\n    border-radius: 10px;\n  }\n\n  &::-webkit-scrollbar {\n    width: 5px;\n    background-color: transparent;\n  }\n\n  &::-webkit-scrollbar-track {\n    display: none;\n  }\n}\n","$ready: #50ae3d;\n$ready-strong: #48813b;\n$ready-shadow: 0 1px 2px 0 rgba($ready, 0.1), 0 4px 12px -4px rgba($ready, 0.28);\n$ready-shadow-hover: 0 1px 2px 0 rgba($ready, 0.12), 0 6px 16px -4px rgba($ready, 0.34);\n\n$hairline: #e4e4e7;\n$rule: #f4f4f5;\n$label: #71717a;\n$focus: #18181b;\n$tracking-caps: 0.08em;\n\n$visit-kinds: (\n  followUp: (\n    base: #69945f,\n    strong: #48813b,\n  ),\n  consultation: (\n    base: #6687bd,\n    strong: #4972b7,\n  ),\n  infusion: (\n    base: #8e7ab5,\n    strong: #8065b1,\n  ),\n  assessment: (\n    base: #3c9888,\n    strong: #088272,\n  ),\n  carePlan: (\n    base: #3c93ac,\n    strong: #0b7d97,\n  ),\n  other: (\n    base: #7e8791,\n    strong: #6b747e,\n  ),\n);\n\n@mixin focus-ring($offset: 1px) {\n  outline: none;\n\n  &:focus-visible {\n    outline: 2px solid $focus;\n    outline-offset: $offset;\n  }\n}\n\n@mixin line-button {\n  display: inline-flex;\n  align-items: center;\n  gap: 4px;\n  padding: 2px 8px;\n  border: 1px solid transparent;\n  border-radius: 6px;\n  background: transparent;\n  font: inherit;\n  font-size: 14px;\n  font-weight: 500;\n  white-space: nowrap;\n  color: #18181b;\n  text-decoration: underline;\n  text-decoration-color: #d4d4d8;\n  text-underline-offset: 3px;\n  cursor: pointer;\n  transition: background-color 0.15s, border-color 0.15s;\n\n  &:hover:not(:disabled) {\n    border-color: #d4d4d8;\n    background: #ffffff;\n    box-shadow: 0 1px 2px rgba(0, 0, 0, 0.05);\n    text-decoration: none;\n  }\n\n  @include focus-ring;\n\n  &:disabled,\n  &[aria-disabled='true'] {\n    color: #a1a1aa;\n    cursor: default;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"fontS10": `Headline-module__font-s-10___v_zM8`,
	"fontS12": `Headline-module__font-s-12___pct9G`,
	"fontS13": `Headline-module__font-s-13___NqCgW`,
	"fontS14": `Headline-module__font-s-14___gjoqY`,
	"fontS15": `Headline-module__font-s-15___nXocI`,
	"fontS16": `Headline-module__font-s-16___wsNqt`,
	"fontS18": `Headline-module__font-s-18___TS3bk`,
	"fontS20": `Headline-module__font-s-20___YyXaV`,
	"fontS22": `Headline-module__font-s-22___hhCMw`,
	"fontS28": `Headline-module__font-s-28___DyDYR`,
	"fontW400": `Headline-module__font-w-400___vkDG5`,
	"fontW500": `Headline-module__font-w-500___um2zz`,
	"fontW600": `Headline-module__font-w-600___bboYu`,
	"fontW700": `Headline-module__font-w-700___RxfXL`,
	"p5": `Headline-module__p-5___LrvDW`,
	"p12": `Headline-module__p-12___eT5Ff`,
	"p16": `Headline-module__p-16___jO8S2`,
	"p30": `Headline-module__p-30___q0JtW`,
	"pB0": `Headline-module__p-b-0___o2zgO`,
	"pB5": `Headline-module__p-b-5___Yo4AT`,
	"pB10": `Headline-module__p-b-10___fdnTl`,
	"pB12": `Headline-module__p-b-12___wAZuw`,
	"pB16": `Headline-module__p-b-16___NLlvl`,
	"pB18": `Headline-module__p-b-18___zMkko`,
	"pB20": `Headline-module__p-b-20___FBCW2`,
	"pB25": `Headline-module__p-b-25___J0mnP`,
	"pB30": `Headline-module__p-b-30___v7bqa`,
	"pB50": `Headline-module__p-b-50___K98hJ`,
	"pT0": `Headline-module__p-t-0___zR2Id`,
	"pT12": `Headline-module__p-t-12___voSNN`,
	"pT16": `Headline-module__p-t-16___Y24mA`,
	"pT18": `Headline-module__p-t-18___tjfbv`,
	"pT20": `Headline-module__p-t-20___fVLSf`,
	"pT30": `Headline-module__p-t-30___Nho_R`,
	"pT40": `Headline-module__p-t-40____izrG`,
	"pT50": `Headline-module__p-t-50___p2svz`,
	"pL20": `Headline-module__p-l-20___PUC9J`,
	"pL30": `Headline-module__p-l-30____9kjq`,
	"pL40": `Headline-module__p-l-40___xab9J`,
	"pR16": `Headline-module__p-r-16___Uo4b7`,
	"pR20": `Headline-module__p-r-20___t8TA_`,
	"pR30": `Headline-module__p-r-30___tLwSF`,
	"pR50": `Headline-module__p-r-50___rP20X`,
	"pR60": `Headline-module__p-r-60___oj7zM`,
	"mB1": `Headline-module__m-b-1___Ocbs1`,
	"mB2": `Headline-module__m-b-2___RraF8`,
	"mB6": `Headline-module__m-b-6___GGZHx`,
	"mB8": `Headline-module__m-b-8___nb8ni`,
	"mB10": `Headline-module__m-b-10___xbOvE`,
	"mB14": `Headline-module__m-b-14___2U_0Y`,
	"mB16": `Headline-module__m-b-16___c1lgU`,
	"mB20": `Headline-module__m-b-20___fSeCe`,
	"mB22": `Headline-module__m-b-22___PU2Ty`,
	"mB24": `Headline-module__m-b-24___I5471`,
	"mB30": `Headline-module__m-b-30___tiZK6`,
	"mB32": `Headline-module__m-b-32___SgCkS`,
	"mB40": `Headline-module__m-b-40___nn3cB`,
	"mT2": `Headline-module__m-t-2___LKufW`,
	"mT3": `Headline-module__m-t-3___VRrGn`,
	"mT4": `Headline-module__m-t-4___B1L7N`,
	"mT5": `Headline-module__m-t-5___TXy8u`,
	"mT8": `Headline-module__m-t-8___sOzYD`,
	"mT10": `Headline-module__m-t-10___TfKu3`,
	"mT15": `Headline-module__m-t-15___QjIuE`,
	"mT16": `Headline-module__m-t-16___qBIDc`,
	"mT20": `Headline-module__m-t-20___rNwXG`,
	"mT22": `Headline-module__m-t-22___MqD8s`,
	"mT30": `Headline-module__m-t-30___t7Lfm`,
	"mT32": `Headline-module__m-t-32___PnhOL`,
	"mLAuto": `Headline-module__m-l-auto___mr4jU`,
	"mL4": `Headline-module__m-l-4___Fkt4T`,
	"mL5": `Headline-module__m-l-5___K0Vc7`,
	"mL6": `Headline-module__m-l-6___pVlp_`,
	"mL8": `Headline-module__m-l-8___XTcNJ`,
	"mL10": `Headline-module__m-l-10___ekVQH`,
	"mL16": `Headline-module__m-l-16___JMpTa`,
	"mL20": `Headline-module__m-l-20___imiPI`,
	"mL24": `Headline-module__m-l-24___t2LT8`,
	"mL30": `Headline-module__m-l-30___Btpuq`,
	"mL35": `Headline-module__m-l-35___KiuWQ`,
	"mL40": `Headline-module__m-l-40___U9dF9`,
	"mR8": `Headline-module__m-r-8___GCvPU`,
	"mR10": `Headline-module__m-r-10___RlIs3`,
	"mR16": `Headline-module__m-r-16___e7vvP`,
	"mR20": `Headline-module__m-r-20___hlPEq`,
	"mR24": `Headline-module__m-r-24___eU95G`,
	"mR30": `Headline-module__m-r-30___hTL_e`,
	"mR40": `Headline-module__m-r-40___tyYwc`,
	"borderR3": `Headline-module__border-r-3___buMTY`,
	"borderR4": `Headline-module__border-r-4___kWt1H`,
	"borderR6": `Headline-module__border-r-6___dTItk`,
	"borderR10": `Headline-module__border-r-10___NcwHm`,
	"borderR12": `Headline-module__border-r-12___UVd7a`,
	"borderR16": `Headline-module__border-r-16___wQX94`,
	"borderR50": `Headline-module__border-r-50___ndzUD`,
	"primaryBorder": `Headline-module__primary-border___BBGX7`,
	"primaryBorderB": `Headline-module__primary-border-b___NnDLc`,
	"primaryBorderT": `Headline-module__primary-border-t___tNt76`,
	"primaryBorderL": `Headline-module__primary-border-l___x8q2H`,
	"primaryBorderR": `Headline-module__primary-border-r___TU3iI`,
	"secondaryBorder": `Headline-module__secondary-border___p7Jv2`,
	"secondaryBorderB": `Headline-module__secondary-border-b___uFpEi`,
	"secondaryBorderT": `Headline-module__secondary-border-t___DZskX`,
	"secondaryBorderL": `Headline-module__secondary-border-l___a8JJY`,
	"secondaryBorderR": `Headline-module__secondary-border-r___Xh2IR`,
	"gap0": `Headline-module__gap-0____Gzac`,
	"gap2": `Headline-module__gap-2___oJVk8`,
	"gap4": `Headline-module__gap-4___fhHHx`,
	"gap5": `Headline-module__gap-5___kePvj`,
	"gap6": `Headline-module__gap-6___M2JRy`,
	"gap8": `Headline-module__gap-8___dNcAG`,
	"gap10": `Headline-module__gap-10___WoEl3`,
	"gap12": `Headline-module__gap-12___neQpf`,
	"gap14": `Headline-module__gap-14___oAqHO`,
	"gap16": `Headline-module__gap-16___XKVnC`,
	"gap18": `Headline-module__gap-18___viwge`,
	"gap20": `Headline-module__gap-20___nZgXn`,
	"gap24": `Headline-module__gap-24___mSF8f`,
	"gap26": `Headline-module__gap-26___e23KF`,
	"gap30": `Headline-module__gap-30___dNhpl`,
	"gap32": `Headline-module__gap-32___aDKM7`,
	"gap40": `Headline-module__gap-40___kTgoj`,
	"gap50": `Headline-module__gap-50___kudDr`,
	"flex1": `Headline-module__flex-1___DWsX7`,
	"flexNone": `Headline-module__flex-none___Aq6sj`,
	"flexColumn": `Headline-module__flex-column___meZeE`,
	"flexRow": `Headline-module__flex-row___uXTAb`,
	"verticallyCentered": `Headline-module__vertically-centered___rHzLx`,
	"horizontallyCentered": `Headline-module__horizontally-centered___jdSRD`,
	"horizontallyEnd": `Headline-module__horizontally-end___hZmlN`,
	"verticallyStart": `Headline-module__vertically-start___DY2OM`,
	"spaceBetween": `Headline-module__space-between___r6_1h`,
	"flexWrap": `Headline-module__flex-wrap___g6jgV`,
	"height100": `Headline-module__height-100___bwRSp`,
	"width50": `Headline-module__width-50___dCmv3`,
	"width100": `Headline-module__width-100___wS35R`,
	"cursorPointer": `Headline-module__cursor-pointer___UuXWz`,
	"cursorNotAllowed": `Headline-module__cursor-not-allowed___vfOAB`,
	"absoluteCentered": `Headline-module__absolute-centered___JM0C7`,
	"absolute": `Headline-module__absolute___lQE5R`,
	"relative": `Headline-module__relative___LJ4aZ`,
	"fixed": `Headline-module__fixed___VwkV6`,
	"visible": `Headline-module__visible___o9wCN`,
	"invisible": `Headline-module__invisible___IlB87`,
	"col90": `Headline-module__col-90___OeNsZ`,
	"colAuto": `Headline-module__col-auto___VBDzp`,
	"medicalTabs": `Headline-module__medical-tabs___JIdyD`,
	"medicalTableNew": `Headline-module__medical-table-new___ia_hr`,
	"noPagination": `Headline-module__no-pagination___HcoQO`,
	"medicalTableEmpty": `Headline-module__medical-table-empty___snko0`,
	"iconBtn": `Headline-module__icon-btn___APFtE`,
	"searchIcon": `Headline-module__search-icon___lH97p`,
	"disableSelect": `Headline-module__disable-select___ZUKe6`,
	"breakWord": `Headline-module__break-word___t3_uC`,
	"popupClearBtn": `Headline-module__popup-clear-btn___HZDu3`,
	"scrollMB20": `Headline-module__scroll-m-b-20___I_KFH`,
	"row": `Headline-module__row___hMMRW`,
	"divider": `Headline-module__divider___vtgYp`,
	"cardBody": `Headline-module__cardBody___cpwgO`,
	"afterCorner": `Headline-module__afterCorner___BuQUN`,
	"titleStack": `Headline-module__titleStack___LpzVh`,
	"title": `Headline-module__title___nmNOd`,
	"inlineStack": `Headline-module__inlineStack___AlJTS`,
	"inlineTitle": `Headline-module__inlineTitle___B1w_s`,
	"toggleTitle": `Headline-module__toggleTitle___mzAYT`,
	"inlineTime": `Headline-module__inlineTime___ypTvH`,
	"timeLine": `Headline-module__timeLine___tVP63`,
	"local": `Headline-module__local___xrm9X`,
	"timeParts": `Headline-module__timeParts___hvVPV`,
	"timePart": `Headline-module__timePart___VQxA8`,
	"when": `Headline-module__when___qxgeN`,
	"soon": `Headline-module__soon___hbH85`,
	"aside": `Headline-module__aside___laThH`,
	"panelBody": `Headline-module__panelBody___E09Ei`,
	"panelText": `Headline-module__panelText___kpToN`,
	"panelTitle": `Headline-module__panelTitle___NwVUD`,
	"muted": `Headline-module__muted___rFGKa`,
	"visitLine": `Headline-module__visitLine___jvPj1`,
	"visitName": `Headline-module__visitName___ohKM_`,
	"description": `Headline-module__description___gFCoL`,
	"actions": `Headline-module__actions___Cy3jM`,
	"panelBodyLarge": `Headline-module__panelBodyLarge___rXPw0`,
	"panelTextLarge": `Headline-module__panelTextLarge___vba4a`,
	"panelTitleLarge": `Headline-module__panelTitleLarge___zKlSx`
};
module.exports = ___CSS_LOADER_EXPORT___;
